export default {
  listaEventTypeFields: [],
  eventTypeField: {
    nome: '',
    tipoEvento: {
      id: '',
    },
    tipoCampo: '',
    obrigatorio: false,
    ordem: 0,
    ativo: true,
  },
}
